import { render, staticRenderFns } from "./GraphFertilizers.vue?vue&type=template&id=353b4382&"
import script from "./GraphFertilizers.vue?vue&type=script&lang=js&"
export * from "./GraphFertilizers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports